import {
  RECEIVED_WHITELISTED_PROPERTIES,
  RECEIVED_SAVED_PROPERTIES,
  RECEIVED_SAVED_PROPERTY,
  RECEIVED_UNSAVED_PROPERTY
} from './actions'
import { append, remove } from '../../utils/map'

export default function reducer (state = {
  whitelisted: {},
  saved: new Map()
}, action) {
  switch (action.type) {
    case RECEIVED_WHITELISTED_PROPERTIES:
      return {
        ...state,
        whitelisted: action.whitelisted
      }
    case RECEIVED_SAVED_PROPERTIES:
      return {
        ...state,
        saved: action.properties
      }
    case RECEIVED_SAVED_PROPERTY:
      return {
        ...state,
        saved: append(state.saved, action.property.id, action.property)
      }
    case RECEIVED_UNSAVED_PROPERTY:
      return {
        ...state,
        saved: remove(state.saved, action.propertyId)
      }
    default:
      return state
  }
}
